module.exports = __webpack_public_path__ + "static/img/3-info-b3-img1.b21430d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/3-info-b3-img1.png
// module id = Is2o
// module chunks = 0